import { motion, useReducedMotion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: easing, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
